import { useDispatch, useSelector } from 'react-redux'
import classes from './HeaderCell.module.css'
import { useState } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { filterActions } from '../../../store/filter'
import { fetchWorkQNow } from '../../../lib/hooks'
import { customWorkQSlugs } from '../pages/custom/globalWorkQStructure'

const HeaderCell = ({item}) => {
    const dispatch = useDispatch()
    const [sortDirection, setSortDirection] = useState(true)

    const orderFilters = useSelector(state => state.filter.orderFilters)
    const loading = useSelector(state => state.filter.loading)
    const workq = useSelector(state => state.workqueue.selectedWorkQueue)
    let { workqSlug } = useParams()
    const location = useLocation()

    if (!workqSlug) {
        customWorkQSlugs.forEach(slug => {
            if (location.pathname.includes(slug)) {
                workqSlug = slug
            }
        })
    }
    const slug = workqSlug || workq?.slug

    async function sortTableHandler() {
        dispatch(filterActions.setMasterLoading(true))
        setSortDirection(prev => prev = !prev)
        const nextOrderFilters = {
            id: item.group + item.label,
            group: item.group,
            label: item.label,
            isDesc: sortDirection
        }

        if (slug) {
            const startedAt = typeof performance !== 'undefined' ? performance.now() : Date.now()
            if (typeof window !== 'undefined') {
                window.__skipNextWorkQFetch = { slug, at: startedAt }
            }
            fetchWorkQNow(slug, { orderFilters: nextOrderFilters, onPage: 1 })
        }

        setTimeout(() => {
            dispatch(filterActions.setOrderFilters(nextOrderFilters))
            dispatch(filterActions.setCurrentPage(1))
        }, 0)
    }


    return <div className={classes.header_cell} > 
        <div>
            {item.name} 
        </div>
        {item.sortable ? <button onClick={sortTableHandler} disabled={loading} className={`${classes.button} ${(orderFilters && orderFilters.id == item.group+item.label )? classes.active : ''}`}>
            {loading && <span className={`loader`}></span>}
            {!loading && <>
                {(orderFilters && orderFilters.id == item.group+item.label) ?  <>
                        {orderFilters.isDesc && <i className='ti ti-sort-descending'></i>}
                        {!orderFilters.isDesc && <i className='ti ti-sort-ascending'></i>}
                    </>
                    : <i className='ti ti-sort-descending'></i>}
            </>}
        </button> : ''}
    </div>
}

export default HeaderCell